import _ from 'lodash';
import * as Yup from 'yup';

import {isDisplayMode, isDisplayStatus, isRecId} from "../../components/utils";
import {FIELD_TYPES} from "../../data";
import {getAPIVersion} from "../../helpers/getAirtableMetaAPIVersion";

const ft = FIELD_TYPES(getAPIVersion());
/* eslint-disable */
export type ValidationSchema = {
  schema: any;
  required?: string;
};

export const atFieldValidationSchemas = (field:any): {
  [index: string]: ValidationSchema;
} => {
  const strict = _.get(field,'strict', true)
  const min = _.get(field, [ft.FT_SINGLE_LINE, ft.FT_MULTI_LINES, ft.FT_RICH_TEXT].includes(field.type) ? 'minlength' : 'min', null)
  const max = _.get(field, [ft.FT_SINGLE_LINE, ft.FT_MULTI_LINES, ft.FT_RICH_TEXT].includes(field.type) ? 'maxlength' : 'max', null)
  const map: {
    [index: string]: ValidationSchema;
  } = {
    [ft.FT_SINGLE_LINE]: {
    schema: Yup.string(),
  },
    [ft.FT_EMAIL]: {
      schema: Yup.string().nullable().strict(),
  },
    [ft.FT_URL]: {
    schema:  Yup.string().nullable().strict(),
  },
    [ft.FT_MULTI_LINES]: {
    schema: Yup.string().nullable().strict(),
  },
    [ft.FT_RICH_TEXT]: {
    schema: Yup.string().nullable().strict(),
  },
    [ft.FT_SINGLE_SELECT]: {
    schema: Yup.string().nullable().strict(),
  },
    [ft.FT_MULTI_SELECTS]: {
    schema: Yup.array().nullable().of(Yup.string()),
  },
    [ft.FT_SINGLE_COLLAB]: {
    schema: Yup.mixed().nullable(),
  },
    [ft.FT_MULTI_COLLABS]: {
    schema: Yup.array().nullable().of(
        Yup.mixed(),
    ),
  },
    [ft.FT_RECORD_LINKS]: {
      schema: Yup.array().nullable().of(
          Yup.mixed(),
      ),
    },
    // [ft.FT_DATE: {
    //   schema: Yup.date().nullable().strict(),
    // },
    // [ft.FT_DATETIME: {
    //   schema: Yup.date().nullable().strict(),
    // },
    [ft.FT_PHONE]: {
    schema: Yup.string().nullable().strict(),
  },
    [ft.FT_ATTACHMENTS]: {
    schema: Yup.array().of(
        Yup.object().strict().shape({
          url: Yup.string(),
        }),
    ),
  },
    [ft.FT_CHECKBOX]: {
    schema: Yup.boolean(),
  },
    [ft.FT_FORMULA]: null,
      // [ft.FT_CREATED: {
      //   schema: Yup.date().nullable().strict(),
      // },
      [ft.FT_ROLLUP]: null,
      [ft.FT_LOOKUP]: {
    schema: Yup.array(),
  },
    [ft.FT_BARCODE]: {
    schema: Yup.string().nullable().strict(),
  },
    [ft.FT_NUMBER]: {
      schema: Yup.number().nullable()
    },
    [ft.FT_CURRENCY]: {
      schema: Yup.number().nullable()
    },
    [ft.FT_PERCENT]: {
      schema: Yup.number().nullable()
    }
    // [ft.FT_LAST_MODIFIED]: {
    //   schema: Yup.date().nullable().strict(),
    // },
    // [ft.FT_BUTTON]: null,
    // [ft.FT_CREATED_BY]: {
    //   schema: Yup.date().nullable().strict(),
    // },
    // [ft.FT_LAST_MODIFIED_BY]: {
    //   schema: Yup.date().nullable().strict(),
    // },
  }
  const minMaxFieldTypes = [ft.FT_SINGLE_LINE, ft.FT_MULTI_LINES,ft.FT_RICH_TEXT, ft.FT_NUMBER,ft.FT_CURRENCY,ft.FT_PERCENT,ft.FT_MULTI_SELECTS,ft.FT_RECORD_LINKS,ft.FT_ATTACHMENTS,ft.FT_MULTI_COLLABS]
  if(max){
    for(let fieldType of minMaxFieldTypes) {
      map[fieldType].schema = map[fieldType].schema.max(Number(max))
    }
  }
  if(min){
    for(let fieldType of minMaxFieldTypes) {
      map[fieldType].schema = map[fieldType].schema.min(Number(min))
    }
  }
  if(strict){
    map[ft.FT_URL].schema = map[ft.FT_URL].schema.url()
    map[ft.FT_EMAIL].schema = map[ft.FT_EMAIL].schema.email('Invalid email address!')
  }
  return map
};

export const staticFieldValidationSchemas = (field:any) => {
  return {
    custom_select: {
      schema: Yup.string().nullable().strict(),
    },
    custom_sub_select: {
      schema: Yup.string().nullable().strict(),
    },
    custom_display: {
      schema: Yup.string().nullable().strict(),
    },
    custom_divider: null,
    custom_spacer: null,
        custom_linked_set: {
    schema: Yup.array().of(Yup.string()),
  },
    custom_standard: null,
        custom_text: {
    schema: Yup.string().nullable().strict(),
  },
  }
};

export const DefaultValidationSchemas = (field:any) =>  {
  const map = {
  ...atFieldValidationSchemas(field),
  ...staticFieldValidationSchemas(field),
  }
  return map[field.type]
};

export const getValidationSchema = (recId, fields) => {
  const isCreate = !isRecId(recId)
  const isEdit = !isCreate
  return Yup.object().shape(
    {
      ...fields.reduce((acc, field) => {
        let { schema, required: requiredMSG = '' } = DefaultValidationSchemas(field) || {};

        if (!schema) {
          return acc;
        }

        if (isDisplayStatus(field, 'require') && isDisplayMode(field, ['hide', isEdit ? 'hide_edit' : 'hide_create'], true) ) {
          console.log("REQUIRED FIELD", schema, field)
          if(schema.type === 'array'){
            schema = schema.min(1)
          }
          schema = schema.required(requiredMSG ? requiredMSG : `${field.name} is required!`);
        }
        acc[field.id] = schema;
        return acc;
      }, {}),
    },
    [],
  );
  /* eslint-enable */
};
